<div *ngIf="editType === 'editCommentExistingImage'">
  <div *ngIf="imageUrl && imageName && imageType">
    <app-image-edit [imageUrl]="imageUrl" [imageName]="imageName" [imageType]="imageType" (changeEditImage)="onChangeEdit($event)"></app-image-edit>
  </div>
</div>
<div *ngIf="editType === 'editCommentNewImage' || editType === 'editUploadImage'">
  <div *ngIf="imageFile">
    <app-image-edit [editImage]="imageFile" (changeEditImage)="onChangeEdit($event)"></app-image-edit>
  </div>
</div>